import D2C_ServiceData from './Data'

class D2C_ServiceCrate extends D2C_ServiceData {
  static objectType = 'serviceType'
  static active = false
  static typeName = 'crate'
  static typeTitle = 'Crate'
  static color = '#00ccee'
  static fields = {
    ...D2C_ServiceData.fields,
    configs: {
      ...D2C_ServiceData.fields.configs,
      default: [
        {name: 'crate.yml', text: require('raw-loader!@/assets/configs/crate-crate.yml').default, custom: false},
      ],
    },
    env: {
      ...D2C_ServiceData.fields.env,
      default: [
        {name: 'CRATE_HEAP_SIZE', value: '512m'},
      ],
    },
    hosts: {
      ...D2C_ServiceData.fields.hosts,
      selector: {
        default: ['node'],
      },
    },
    image: {
      ...D2C_ServiceData.fields.image,
      default: 'crate',
    },
    ports: {
      ...D2C_ServiceData.fields.ports,
      default: [
        {protocol: 'TCP', value: 4200},
      ],
    },
    version: {
      ...D2C_ServiceData.fields.version,
      default: '3.1',
      enum: ['2.3', '3.1'],
    },
    volumes: {
      ...D2C_ServiceData.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/data', dst: '/data', sync: false},
        {src: '/ebs/containers/$serviceName/configs', dst: '/crate/config', sync: false},
      ],
    },
  }
}

export default D2C_ServiceCrate
